import type { ConfigOf } from "../../../install/types.ts";
import { widetype } from "../../../util/collections.ts";
import type { SshComponents } from "./components.ts";

export const AWS_TAG_KEY_REGEX = /^[a-zA-Z0-9+-=.,_:@]{0,128}$/;

// https://cloud.google.com/resource-manager/docs/tags/tags-creating-and-managing#creating_tag
export const GCLOUD_TAG_KEY_REGEX = /^(([A-Za-z0-9-])+\/[^'"\\/]{1,256})?$/;

// https://learn.microsoft.com/en-us/azure/azure-resource-manager/management/tag-resources?tabs=json#limitations
export const AZURE_TAG_KEY_REGEX = /^[^<>%&\\?/]{0,512}$/;

export type ProvisionUserAccessParameters = {
  UserName: string[];
  Action: string[];
  RequestId: string[];
  Sudo?: string[];
  PublicKey?: string[];
};

export type SshComponents = typeof SshComponents;

export type SshUse = keyof SshComponents;

export type SshIntegration = ConfigOf<typeof SshComponents>;

export type SshIntegrationConfig = SshIntegration["iam-write"]["config"];

export const SshProviders = {
  aws: { label: "AWS" },
  azure: { label: "Azure" },
  gcloud: { label: "Google Cloud" },
  "self-hosted": { label: "Self hosted" },
};
export const SshProviderKeys = widetype.keys(SshProviders);
export type SshProviderKey = keyof typeof SshProviders;
